// @ts-nocheck
import componentsReducer, { ComponentsActions } from "@store/Framework/Store/Starter/Components/ComponentsReducer";
import dataReducer, { DataActions } from "@store/Framework/Store/Starter/Data/DataReducer";
import pagesReducer, { PagesActions } from "@store/Framework/Store/Starter/Pages/PagesReducer";
import { combineReducers } from "redux";

const starterReducer = combineReducers({
    components: componentsReducer,
    data: dataReducer,
    pages: pagesReducer,
});

export type StarterActions = ComponentsActions | DataActions | PagesActions;

export default starterReducer;
